// UserMainFields.js

import React, { useContext, useEffect } from "react";
import { generateTextField } from "../../b2b-common/helpers";
import B2BFormContainer from "../../b2b-common/B2BFormContainer";
import { Save } from "@mui/icons-material";
import { CircularProgress, Switch, Tooltip } from "@mui/material";
import { enableDisableUser, updateUser } from "../../../services/b2b-users-apiService";
import { LoginContext } from "../../../App";

import './UserMainFields.css';

const UserMainFields = ({ user, onUserUpdate }) => {
    const { loginData } = useContext(LoginContext);

    const [managedUser, setManagedUser] = React.useState(user);
    const [loadingEnableDisableUser, setLoadingEnableDisableUser] = React.useState(false);
    const [savingUser, setSavingUser] = React.useState(false);

    const handleManagedUserChange = (field, value) => {
        setManagedUser((prevManagedUser) => ({
            ...prevManagedUser,
            [field]: value,
        }));
    };

    useEffect(() => {
        setManagedUser(user);
    }, [user]);

    const handleSwitchToggle = async (e) => {
        try {
            setLoadingEnableDisableUser(true);
            const { accessToken } = loginData;
            const updatedUser = await enableDisableUser(managedUser.userUuid, e.target.checked, accessToken);
            setManagedUser(prevManagedUser => ({
                ...prevManagedUser,
                enabled: updatedUser.enabled,
            }));
            onUserUpdate({ ...managedUser, enabled: updatedUser.enabled });
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingEnableDisableUser(false);
        }
    };

    const handleSaveUser = async () => {
        try {
            setSavingUser(true);
            const { accessToken } = loginData;
            const updatedUser = await updateUser(managedUser.userUuid, managedUser, accessToken);
            setManagedUser(updatedUser);
            onUserUpdate(updatedUser);
        } catch (error) {
            console.log(error);
        } finally {
            setSavingUser(false);
        }
    };

    const buttonsConfig = [
        {
            label: 'Save',
            onClick: handleSaveUser,
            isLoading: savingUser,
            variant: 'contained',
            key: '1',
            icon: <Save />,
        },
    ];

    return (
        managedUser && (
            <B2BFormContainer buttonsConfig={buttonsConfig} className="user-main-fields-form">
                <div className="user-main-fields-rows-container">
                    {generateTextField("First Name", managedUser.firstName, "user-field", false, (e) => handleManagedUserChange('firstName', e.target.value), { required: false })}
                    {generateTextField("Last Name", managedUser.lastName, "user-field", false, (e) => handleManagedUserChange('lastName', e.target.value), { required: false })}
                    {generateTextField("Phone", managedUser.phoneNumber, "user-field", false, (e) => handleManagedUserChange('phoneNumber', e.target.value), { required: false })}
                    {generateTextField("eMail", managedUser.email, "user-field", false, (e) => handleManagedUserChange('email', e.target.value), { required: false })}
                    {generateTextField("Locale", managedUser.locale, "user-field", false, (e) => handleManagedUserChange('locale', e.target.value), { required: false })}
                </div>
                <div className="user-main-fields-enabled-switch">
                    {loadingEnableDisableUser ? (
                        <CircularProgress size={20} />
                    ) :
                        <Tooltip title={`Is user enabled?`} arrow placement="right">
                            <Switch
                                checked={managedUser.enabled}
                                onChange={handleSwitchToggle}
                                color="primary"
                                inputProps={{ 'aria-label': 'toggle user enabled' }}
                            />
                        </Tooltip>
                    }
                </div>
            </B2BFormContainer >
        )
    );
};

export default UserMainFields;